import apiReq from '../commontools/api.js'
export function GetGroupItemDataByOrder(OrderID) {
	var url='/GroupItem/GetGroupItemDataByOrder/'+OrderID;
	return apiReq.get(url);
}
export function GetGroupItemDataByGroup(OrderID,GroupID) {

	var url='/GroupItem/GetGroupItemDataByGroup/'+OrderID+'/'+GroupID;
	return apiReq.get(url)
}
export function GetSaleModuleValid(corpid){
	var url='/SaleModule/GetSaleModuleValid/'+corpid;
	return apiReq.get(url)
}
export function ChangeItemPrice(selSaleModule,sum,discount,saleitemall)
{
	let org=0;
	for(let j=0;j<selSaleModule.length;j++)
	{
		org+=selSaleModule[j].OrgPrice;
		let temp = saleitemall.find(v => v.salemoduleid == selSaleModule[j].SaleModuleID);
		selSaleModule[j].MiniDiscount=0;
		if(temp!=undefined )
		{
			selSaleModule[j].MiniDiscount=temp.MiniDiscount;
		}
	}
	
	//this.selSaleModule.sort((a, b) => a.MiniDiscount - b.MiniDiscount).reverse();
	for(let i=0;i<selSaleModule.length;i++)
	{
		if(selSaleModule[i].MiniDiscount<=0)
		{
			continue;
		}
		var li=selSaleModule[i];
		if(sum!='')
		{
			if(org==0)
			return;
			let d=selSaleModule[i].MiniDiscount;//parseFloat(sum/org).toFixed(4);
			li.Discount=d;
			if(i==selSaleModule.length-1)
			li.CurPrice=sum.toFixed(2);
			else
			li.CurPrice=parseFloat(li.OrgPrice*d).toFixed(2);
			org-=li.OrgPrice;
			sum-=li.CurPrice;
		}
		if(discount!='')
		{
			let d=discount;
			if(selSaleModule[i].MiniDiscount>d)
			d=selSaleModule[i].MiniDiscount;
			selSaleModule[i].Discount=d;
			selSaleModule[i].CurPrice=parseFloat(selSaleModule[i].OrgPrice*d).toFixed(2);
			//alert(selSaleModule[i].CurPrice)
		}
	}
	for(let i=0;i<selSaleModule.length;i++)
	{
		if(selSaleModule[i].MiniDiscount>0)
		{
			continue;
		}
		var li=selSaleModule[i];
		if(sum!='')
		{
			if(org==0)
			return;
			let d=parseFloat(sum/org).toFixed(4);
			li.Discount=d;
			if(i==selSaleModule.length-1)
			li.CurPrice=sum.toFixed(2);
			else
			li.CurPrice=parseFloat(li.OrgPrice*d).toFixed(2);
			org-=li.OrgPrice;
			sum-=li.CurPrice;
		}
		if(discount!='')
		{
			selSaleModule[i].Discount=discount;
			selSaleModule[i].CurPrice=parseFloat(selSaleModule[i].OrgPrice*discount).toFixed(2);
			//alert(selSaleModule[i].CurPrice)
		}
	}
}
export function CheckRepeatItem(addSaleModule,selSaleModule,saleitemall){
	var msg='';
	if(selSaleModule.length<1)
	return msg;
		// alert(JSON.stringify(saleitemall) )
	var selSaleItem=[];
	for(let i=0;i<selSaleModule.length;i++)
	{
		var li=selSaleModule[i];
		var templist=saleitemall.filter(itm=>{
			if(itm.salemoduleid==li.SaleModuleID)
			return itm;
		})
		// alert(JSON.stringify(templist.length) )
		if(templist.length>0)
		{
			// selSaleItem.push(templist);
			for(let j=0;j<templist.length;j++)
			{
				// if(selSaleItem.length<1)
				// selSaleItem=templist[j];
				// else
				selSaleItem.unshift(templist[j]);
			}
		}
		
	}
	//alert(JSON.stringify(selSaleItem.length) )
	var templist1=saleitemall.filter(itm=>{
		if(itm.salemoduleid==addSaleModule.SaleModuleID)
		return itm;
	})
	if(templist1.length>0)
	{
		for(let j=0;j<templist1.length;j++)
		{
			var tempitm= selSaleItem.find(itm=>{
				if(templist1[j].checkitemid==itm.checkitemid)
				return itm;
			})
			//alert(JSON.stringify(tempitm) )
			if(tempitm!=null)
			{
				msg='与‘'+tempitm.salemodulename+'’有重复项目';
				break;
			}
		}
	}
	return msg;
}
export function SaveGroupItem(orderid,groupid,salemodulesjson){
	var url='/GroupItem/SaveGroupItem/'+orderid+'/'+groupid;
	// alert(JSON.stringify(salemodulesjson) )
	var p = {
		data: salemodulesjson
	}
	// url+=JSON.stringify(p);
	return apiReq.post(url,p);
}
export function GetSaleItemAll(corpid){
	var url='/SaleModule/GetSaleItemAll/'+corpid;
	return apiReq.get(url)
}
export function GetGroupItemWithFNote(corpid,orderid,groupid){
	var url='/GroupItem/GetGroupItemWithFNote/'+corpid+'/'+orderid+'/'+groupid;;
	return apiReq.get(url)
}

export default{
	GetGroupItemDataByOrder,
	GetGroupItemDataByGroup,
	GetSaleModuleValid,
	CheckRepeatItem,
	SaveGroupItem,
	GetSaleItemAll,
	ChangeItemPrice,
	GetGroupItemWithFNote
}